import React from 'react';
import '../Landing.css';
import { Grid } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import testimonialsSection from '../testimonialsStyle';

const hexToRgb = (input) => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const Comments = (props) => {
  const { classes } = props;
  // const expClasses = useStyles();
  return (
    <div className={classes.testimonials} id="comments">
      <div className={classes.container}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <h2 className={classes.title}>
              Відгуки про програмний комплекс
              <br />
              «Інтегрована інформаційна система «Соціальна громада»
            </h2>
            <h4 className="text-muted">
              “Ми тестуємо програму «ІІС «Соціальна громада» з вересня 2019 року і дуже задоволені. У нас 5 людей
              об’єднані в електронному кабінеті - 4 на рівні ТГ та 1 на рівні старостинського округу. За цей час ми
              прийняли 1042 звернень, це дає нам змогу накопичувати базу даних про наших мешканців, моніторити кількість
              і якість надання адміністративних послуг соціального характеру, стан розгляду заявок, а також швидко
              обраховувати бюджетну потребу для соціального захисту”, зазначає Ірина Грищенко, заступник голови
              Білозірської ТГ
            </h4>
          </Grid>
        </Grid>
        {/* <div style={{ flexGrow: 1, marginTop: "80px" }}>
                    <Grid container spacing={3} direction="row"
                        justify="center"
                        alignItems="stretch"

                    >
                        <Grid item xs={12} sm={4} md={4}>
                            <Card className={expClasses.card}>
                                <CardMedia
                                    className={expClasses.mediaHeader}
                                    image={commentOne}
                                    title="Contemplative Reptile"
                                />
                                <div className={classes.icon}>
                                    <FormatQuote />
                                    </div>
                             <CardContent >
                                <p className={classes.cardDescription}>«Своєчасність надання соціальної допомоги є надважливою для уникнення  потрапляння дітей в інтернати, розпаду сімей, накопичення боргів за комунальні послуги, для вчасного отримання догляду за різними категоріями населення. </p>
                                <div className={classes.icon} style={{float: "right"}}>
                                    <FormatQuote />
                                </div>
                                <h4 className={classes.cardTitle}>Юлія Соколовська</h4>
                                <h6 className={classes.cardCategory}>Міністр соціальної політики</h6>
                                    </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                        <Card className={expClasses.card}>
                                <CardMedia
                                    className={expClasses.mediaHeader}
                                    image={commentOne}
                                    title="Contemplative Reptile"
                                />
                                <div className={classes.icon}>
                                    <FormatQuote />
                                    </div>
                             <CardContent >
                                <p className={classes.cardDescription}>«Своєчасність надання соціальної допомоги є надважливою для уникнення  потрапляння дітей в інтернати, розпаду сімей, накопичення боргів за комунальні послуги, для вчасного отримання догляду за різними категоріями населення. </p>
                                <div className={classes.icon} style={{float: "right"}}>
                                    <FormatQuote />
                                </div>
                                <h4 className={classes.cardTitle}>Юлія Соколовська</h4>
                                <h6 className={classes.cardCategory}>Міністр соціальної політики</h6>
                                    </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                        <Card className={expClasses.card}>
                                <CardMedia
                                    className={expClasses.mediaHeader}
                                    image={commentOne}
                                    title="Contemplative Reptile"
                                />
                                <div className={classes.icon}>
                                    <FormatQuote />
                                    </div>
                             <CardContent >
                                <p className={classes.cardDescription}>«Своєчасність надання соціальної допомоги є надважливою для уникнення  потрапляння дітей в інтернати, розпаду сімей, накопичення боргів за комунальні послуги, для вчасного отримання догляду за різними категоріями населення. </p>
                                <div className={classes.icon} style={{float: "right"}}>
                                    <FormatQuote />
                                </div>
                                <h4 className={classes.cardTitle}>Юлія Соколовська</h4>
                                <h6 className={classes.cardCategory}>Міністр соціальної політики</h6>
                                    </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </div> */}
      </div>
    </div>
  );
};

export default withStyles(testimonialsSection)(Comments);
